import React from 'react';
import NavBar from '../NavBar/NavBar';
import { Link } from 'react-router-dom';
import firebase from 'firebase/app'



function Login (props) {
    const [state, setState] = React.useState({
        username: '',
        email : '',
        name : '',
        password: '',
        showReset: false,
        btnText : "Signup",
    })
    const showReset = () => { setState({ 
        ...state,
        showReset: !state.showReset
    }); }

    const handleSignup = () => {
        setState({
            ...state,
            btnText : "Wait..."
        })
        let {name, username, email, password} = state;
        if(name && username && email && password) {
            // Do register
            firebase.auth().createUserWithEmailAndPassword(email,password)
            .then(user => {
                firebase.firestore().collection("users").doc(user.user.uid)
                .set({
                    name,
                    email,
                    username
                })
                window.location.hash = "#/pens";
            })
            .catch(e => alert(e))

        }
        else alert('All forms required');
        setState({
            ...state,
            btnText : "Signup"
        })
        
}

return (
    <div>
        <NavBar/> 
            <div className="component-login" style={{backgroundColor : "#1D1E22"}}>
            <div className="login-container" style={{width : '60%'}}>
                <div className="login-header text-center">
                    <h1 className="text-black mb-10">Signup</h1>
                </div>
                <div className="signup-input-group px-48">
                    <h5>NAME</h5>
                    <input onChange={(e) => setState({
                        ...state,
                        name : e.target.value
                    })} 
                    name='credentials' value={state.name} type="text" className="signup-input py-1 px-5" />
                </div>
                <div className="signup-input-group px-48">
                    <h5>USERNAME</h5>
                    <input onChange={(e) =>setState({
                        ...state,
                        username : e.target.value
                    })} name='password' value={state.username} type="text" className="signup-input py-1 px-5" />
                </div>

                <div className="signup-input-group px-48">
                    <h5>EMAIL</h5>
                    <input onChange={(e) =>setState({
                        ...state,
                        email : e.target.value
                    })} name='password' value={state.email} type="email" className="signup-input py-1 px-5" />
                </div>

                <div className="signup-input-group px-48">
                    <h5>PASSWORD</h5>
                    <input onChange={(e) =>setState({
                        ...state,
                        password : e.target.value
                    })} name='password' value={state.password} type="password" className="signup-input py-1 px-5" />
                </div>

                <div className="flex flex-row px-60 w-full justify-around">
                    <button onClick={handleSignup} className="px-4 py-4 bg-green-400 hover:bg-green-500 rounded text-white">{state.btnText}</button>
                    <p className="text-large text-blue-400 hover:text-blue-500 align-center cursor-pointer align-middle pt-3" onClick={showReset}>Forgot Password?</p>
                </div>
                <div className={state.showReset ? 'reset' : 'hidden'}>
                    <div className="reset-styles">
                        <h3>Reset Your Password</h3>
                        <div className="reset-input-group">
                            <h6>Username Or Email</h6>
                            <input required placeholder='your@email.com' type="text" />
                        </div>
                        <div className="reset-button">
                            <button>Send Password Reset Email</button>
                        </div>
                    </div>
                </div>
            <div className="login-signup-container">
                <p>Already have an account? </p>
                    <Link to="/login"><span className="px-5 text-blue-400 hover:text-blue-500">Login here!</span></Link>
            </div>
        </div>
    </div>
</div>
        )
}


export default Login;


// WEBPACK FOOTER //
// ./src/components/SignUp/SignUp.js